(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/index.js');
"use strict";


const {
  Form,
  ControlGroup,
  Input
} = svs.ui.reactForm;
const Icon = svs.ui.ReactIcon;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const TicketGifts = _ref => {
  let {
    history,
    faultyBarcode,
    windowObject = window
  } = _ref;
  const {
    reactPayfooterCustomerServiceTexts
  } = svs.ticket_gifts.constants;
  const [barcode, setBarcode] = React.useState('');
  React.useEffect(() => {
    faultyBarcode && !barcode && setBarcode(faultyBarcode);
  }, [faultyBarcode]);
  const trimStr = str => str.replace(/ /g, '');
  const handleInputChange = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    value = trimStr(value);
    if (value.length > 12) return;
    if (faultyBarcode) {
      history && history.replace(history.location.pathname);
    }
    setBarcode(value);
  };
  const handleSubmitBarcode = e => {
    e && e.preventDefault();
    windowObject.location.href = "".concat(svs.core.data.baseUrl, "/").concat(barcode, "?manual=true");
  };
  const handleOnCancel = e => {
    e && e.preventDefault();
    windowObject.location.href = svs.core.urlMapping.get('startPage');
  };
  const handleKeyDown = e => {
    if (e.key === 'Enter' && barcode) {
      e.preventDefault();
      windowObject.location.href = "".concat(svs.core.data.baseUrl, "/").concat(barcode);
      return false;
    }
  };
  const payfooterButtons = [{
    primary: true,
    text: 'Fortsätt',
    onClick: handleSubmitBarcode
  }, {
    secondary: true,
    text: 'Avbryt',
    onClick: handleOnCancel
  }];
  const errorMessage = React.createElement("span", null, "Hoppsan! Koden \xE4r felaktigt inmatad eller f\xF6rbrukad. Kontrollera koden och f\xF6rs\xF6k igen. Har du precis f\xF6rs\xF6kt l\xF6sa in din presentlott, kontrollera om lotten finns i", ' ', React.createElement("a", {
    href: svs.core.urlMapping.get('myBetsHome')
  }, "Mina spel"), ". Om koden \xE4r \xE4ldre \xE4n ett \xE5r \xE4r den utg\xE5ngen och g\xE5r inte l\xE4ngre att l\xF6sa in.");
  const hasError = Boolean(faultyBarcode) && faultyBarcode === barcode;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-container"
  }, React.createElement("div", {
    className: "ticket-gifts-img-container"
  }, React.createElement("img", {
    alt: "",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png")
  })), React.createElement("h1", {
    className: "f-bold f-center"
  }, "L\xF6s in din presentlott"), React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    errorMessage: errorMessage,
    hasError: hasError
  }, React.createElement(Input, {
    className: "qa-ticket-gifts-input",
    label: "Ange din kod h\xE4r (12 tecken)",
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    value: barcode && barcode.replace(/(.{3})/g, '$1 ').trim() || ''
  }))), React.createElement("div", {
    className: "ticket-gifts-info-container padding-1"
  }, React.createElement("div", {
    className: "padding-1"
  }, React.createElement(Icon, {
    icon: "help-2"
  })), React.createElement("div", null, "Oinl\xF6sta lotter du f\xE5tt via SMS eller e-post l\xF6ser du in enklast via l\xE4nken i ditt SMS eller e-post."))), React.createElement(Payfooter, {
    buttons: payfooterButtons,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.components.TicketGifts', TicketGifts);

 })(window);